module.exports = __webpack_public_path__ + "static/media/logoCelebration.b8921569.png";